<template>
    <a-layout id="login">
        <loginBg
            v-if="!loading"
            :dotNum="30"
            :styleObj="{
                position: 'absolute',
                zIndex: '0',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%'
            }"
        ></loginBg>
        <a-spin tip="登录中..." v-if="loading" style="position: relative; z-index: 5;"></a-spin>
        <a-layout-content class="login_content" v-if="!loading">
            <div class="login_logo">
                <ul>
                    <li><img src="/static/img/logo3.png" /></li>
                    <li>
                        <icon-font type="icon-qiyeweixinfuwushang2" class="logo_icon" />
                    </li>
                </ul>
            </div>
            <div class="box_wrapper">
                <div class="login_box" :class="position ? 'position' : ''">
                    <a-row type="flex" justify="space-between" align="middle" class="row">
                        <a-col :span="15" class="col col_left">
                            <swiper class="swiper" :options="swiperOption">
                                <swiper-slide
                                    v-for="item in coverList"
                                    :key="item.id"
                                    class="swiper_item dir_left_wrap"
                                >
                                    <img :src="item.url" />
                                </swiper-slide>
                                <div
                                    class="swiper-pagination"
                                    slot="pagination"
                                    v-if="coverList.length > 1"
                                ></div>
                            </swiper>
                        </a-col>
                        <a-col :span="9" class="col col_right">
                            <h1 class="main_center cross_center">
                                <span class="main_center cross_center">
                                    <!-- <img src="/static/img/logo1.png" /> -->
                                    <icon-font type="icon-jihuiguanjia" class="col_icon" />
                                </span>
                            </h1>
                            <h3>机汇管家登录</h3>
                            <a-row class="cont" type="flex" justify="center" align="middle">
                                企业私域流量运营神器
                            </a-row>
                            <a-button
                                type="primary"
                                size="large"
                                block
                                @click="toJump"
                                class="login_btn"
                            >
                                <icon-font
                                    type="icon-xingzhuang"
                                    :style="{ fontSize: '18px', transform: 'translateY(3px)' }"
                                />
                                企业微信登录
                            </a-button>
                        </a-col>
                    </a-row>
                </div>
            </div>
        </a-layout-content>
        <a-layout-footer class="login_footer" v-if="!loading">
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
                浙ICP备14038176号-11
            </a>
        </a-layout-footer>
    </a-layout>
</template>

<script>
import api from '@/apis';
import iconFont from '/public/commom.js';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import loginBg from '@/components/common/base/login_bg';
export default {
    components: {
        loginBg,
        Swiper,
        SwiperSlide,
        iconFont
    },
    directives: {
        swiper: directive
    },
    data() {
        return {
            loading: false,
            position: true,
            screenHeight: 0,
            coverList: [{ id: 1, url: '/static/img/loginBanner.jpg' }],
            swiperOption: {
                autoplay: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            },
            loginConfig: {}
        };
    },
    mounted() {
        this.screenHeight = document.documentElement.clientHeight / 2 - 450;
        window.onresize = () => {
            this.screenHeight = document.documentElement.clientHeight / 2 - 450;
        };
        window.sessionStorage.setItem('redirect', this.$route.query.redirect || '');
        if (this.$route.query && this.$route.query.auth_code) {
            this.loading = true;
            this.toLogin();
        }
    },
    watch: {
        screenHeight(val) {
            this.position = val > 0 ? true : false;
        }
    },
    methods: {
        toJump() {
            const redirectUri = encodeURIComponent(window.location.href);
            window.location.href = `https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=${process.env.VUE_APP_LOGIN_APPID}&redirect_uri=${redirectUri}&state=STATE&usertype=${process.env.VUE_APP_USERTYPE}`;
        },
        async toLogin() {
            try {
                const res = await api.postLogin({
                    code: this.$route.query.auth_code,
                    state: this.$route.query.state
                });
                if (res.code === 0) {
                    window.sessionStorage.setItem('token', res.token);
                    window.sessionStorage.setItem('avatar', res.avatar);
                    window.sessionStorage.setItem('expTime', res.expTime);
                    window.sessionStorage.setItem('userName', res.userName);
                    this.$router.push({
                        path: window.sessionStorage.getItem('redirect') || '/home'
                    });
                } else {
                    this.$router.push({ path: '/401' });
                }
            } catch (err) {
                console.log(err);
            }
        }
    }
};
</script>

<style scoped lang="less">
.pos(@position) when(@position > 0) {
    top: calc(50vh - 450px);
}
.pos(@position) when(@position <= 0) {
    top: 0;
}
#login {
    width: 100%;
    height: 100vh;
    // background: #ff5800;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}
#login .login_content {
    width: 72.6%;
    min-width: 800px;
    height: 100vh;
    margin: 0 auto;
    position: relative;
    z-index: 5;
}
#login .login_content .login_logo {
    padding: 3% 0 5% 0;
    position: relative;
}
#login .login_content .login_logo ul {
    font-size: 0;
    margin: 0 -15px;
}
#login .login_content .login_logo ul li {
    display: inline-block;
    vertical-align: middle;
    padding: 0 15px;
    position: relative;
}
#login .login_content .login_logo ul li:first-child::after {
    content: '';
    display: block;
    width: 1px;
    height: 16px;
    background: #dbdbdb;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
}
#login .login_content .login_logo ul li img {
    display: block;
    height: 26px;
}
#login .login_content .login_logo ul li .logo_icon {
    font-size: 156px;
    position: absolute;
    top: 0;
    right: -131px;
    transform: translateY(-50%);
}
#login .login_content .box_wrapper {
    width: 100%;
    // height: calc(100vh - 90px);
    position: relative;
    /* display: flex;
    align-items: center;
    justify-content: center; */
}
#login .login_content .login_box {
    width: 100%;
    // height: 75%;
    min-height: 442px;
    // max-height: 606px;
    /* height: 553.5px; */
    background: #fff;
    flex: unset;
    box-sizing: border-box;
    position: absolute;
    text-align: center;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    border-radius: 30px;
    overflow: hidden;
}
#login .login_content .login_box.position {
    top: calc(50vh - 450px);
}
#login .login_content .login_box:after {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    width: 1px;
    height: 100%;
    background: #f5f5f5;
}
#login .login_content .row,
#login .login_content .row .col_left,
#login .login_content .row .swiper-container,
#login .login_content .swiper_item {
    height: 100%;
    // max-height: 606px;
    // min-height: 520px;
}
#login .login_content .swiper_item {
    width: 100% !important;
}
#login .login_content .swiper_item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
#login .login_content .col_right {
    padding: 0 6%;
}
#login .login_content h1 span {
    width: 90px;
    height: 90px;
    border: 1px solid #e6e6e6;
    border-radius: 20px;
    padding: 4px;
    margin-bottom: 4px;
}
#login .login_content h1 span .col_icon {
    font-size: 80px;
}
#login .login_content h1 img {
    height: 70%;
}
#login .login_content h3 {
    font-size: 24px;
    line-height: 1;
    font-weight: 400;
    margin: 20px 0;
}
#login .login_content .cont {
    margin: 0 0 15% 0;
    font-size: 15px;
    color: #737373;
    line-height: 1;
}
#login .login_btn i {
    font-size: 20px !important;
}
// #login .login_btn {
//     height: 53px;
//     line-height: 53px;
//     font-size: 20px;
// }
// #login .login_btn i {
//     font-size: 25px !important;
// }
#login .login_footer {
    background: none;
    padding: 30px;
    position: relative;
    z-index: 2;
}
#login .login_footer a {
    color: rgba(255, 255, 255, 0.5);
}
@media (max-width: 1400px) {
    #login .login_content .login_box {
        min-height: inherit;
    }
    #login .login_content h1 span {
        width: 90px;
        height: 90px;
    }
    #login .login_content h3 {
        font-size: 22px;
    }
}
</style>
